import React from 'react';
import { TranslationView } from '@levelapp/softfabric-ui';
import {Image, ImageBackground, Text, View} from 'react-native';
import {styles} from "./FooterViewStyle";
import {useWindowSizeContext} from "../../../../../Common/contexts/WindowSizeContext";

interface FooterViewProps {

}

export const FooterView = ({}:FooterViewProps) => {
    const {width, height, isMobile} = useWindowSizeContext();

    const footerHeight = calculateHeight();

    function calculateHeight() {
        if (width <= 500) {
            if (height <= 700) return height * 0.75;
            return height * 0.6;
        }
        if (height <= 700) return height * 0.75;
        if (height <= 900) return height * 0.5;

        return height * 0.35;
    }

    const footerFontSize = isMobile ? 10 : 12;
    const footerLinkStyle = [
        styles.footerLink,
        {
            color: '#f7f7f7',
            fontSize: footerFontSize*1.5,
            marginRight: isMobile ? 0 : 50,
        }
    ];
    const footerIconStyle = [
        {
            height: 32,
            width: 32,
            marginRight: 12
        }
    ];
    const footerHrefStyle = {
        color: '#f7f7f7',
        textDecoration: 'none',
    };

    return (
        <ImageBackground source={{uri: "https://beebondsstorage.blob.core.windows.net/files/web/footerBackground.png"}} style={[styles.footer]}>
            <View style={[styles.footerContent]}>
                <Text style={[styles.footerText, {fontSize: footerFontSize*1.17, marginTop: footerHeight*0.05}]}>
                    BeeBonds SRL - Seed Factory - Avenue des Volontaires, 19 - Vrijwilligerslaan, 19 - B - 1160 -Auderghem - Oudergem<br />
                    Tel : +32 (0)2 896 92 98 - Contact : hello@beebonds.com - Site WEB : https://www.beebonds.com/ - N° BCE : BE 0658 962 075<br />
                    Plateforme de Financement Participatif agréée, le 23 avril 2019, par l'Autorité des Services et Marchés Financiers (FSMA) établie Rue du Congrès 12-14 à B - 1000 - Bruxelles - Tel : +32(0)2 220 52 11
                </Text>
                <TranslationView style={[styles.footerTitle, {fontSize: footerFontSize*2}]}>legalInformations</TranslationView>
                <View style={isMobile ? styles.legalsColView : styles.legalsRowView}>
                    <FooterLink
                        hrefLink="https://www.beebonds.com/wp-content/uploads/2024/02/BeeBonds-Conditions-generales-24-02-02-.pdf"
                        hrefStyle={footerHrefStyle}
                        linkTextStyle={[footerLinkStyle, styles.footerLink]}
                        isIconLink={false}
                        linkText="generalConditions"
                    />
                    <FooterLink
                        hrefLink="https://www.beebonds.com/privacy-policy/"
                        hrefStyle={footerHrefStyle}
                        linkTextStyle={[footerLinkStyle, styles.footerLink]}
                        isIconLink={false}
                        linkText="confPolitic"
                    />
                    <FooterLink
                        hrefLink="https://www.beebonds.com/wp-content/uploads/2023/03/BeeBonds-formulaire-de-plainte-.pdf"
                        hrefStyle={footerHrefStyle}
                        linkTextStyle={[footerLinkStyle, styles.footerLink]}
                        isIconLink={false}
                        linkText="FormPleinte"
                    />
                    <FooterLink
                        hrefLink="https://www.beebonds.com/wp-content/uploads/2023/01/09.01-Procedure-de-Prevention-des-Conflits-dInterets_janvier-2023.pdf"
                        hrefStyle={footerHrefStyle}
                        linkTextStyle={[footerLinkStyle, styles.footerLink]}
                        isIconLink={false}
                        linkText="PolitiqueConflits"
                    />
                    <FooterLink
                        hrefLink="https://www.beebonds.com/avertissement/"
                        hrefStyle={footerHrefStyle}
                        linkTextStyle={[footerLinkStyle, styles.footerLink]}
                        isIconLink={false}
                        linkText="WarningOnRisks"
                    />
                </View>
                <View style={styles.legalsRowView}>
                    <FooterLink
                        iconStyle={footerIconStyle}
                        hrefStyle={footerHrefStyle}
                        hrefLink="https://www.linkedin.com/company/beebonds/"
                        footerIcon={require('./assets/linkedin.png')}
                    />
                    <FooterLink
                        iconStyle={footerIconStyle}
                        hrefStyle={footerHrefStyle}
                        hrefLink="https://www.facebook.com/beebondsFinance"
                        footerIcon={require('./assets/fb.png')}
                    />
                    <FooterLink
                        iconStyle={footerIconStyle}
                        hrefStyle={footerHrefStyle}
                        hrefLink="https://www.instagram.com/beebonds/"
                        footerIcon={require('./assets/insta.png')}
                    />
                    <FooterLink
                        iconStyle={footerIconStyle}
                        hrefStyle={footerHrefStyle}
                        hrefLink="https://twitter.com/BeebondsFinance"
                        footerIcon={require("./assets/twitter.png")}
                    />
                    <FooterLink
                        iconStyle={footerIconStyle}
                        hrefStyle={footerHrefStyle}
                        hrefLink="https://www.youtube.com/channel/UCnkoOsHOn5OYzbMI2u5Sh2A"
                        footerIcon={require("./assets/yt.png")}
                    />
                </View>
            </View>
        </ImageBackground>
    );
}

type FooterProps = {
    iconStyle?: any;
    hrefStyle: any;
    hrefLink: string;
    footerIcon?: any;
    isIconLink?: boolean;
    linkText?: string;
    linkTextStyle?: any;
}

const FooterLink = ({iconStyle={}, hrefStyle, hrefLink, footerIcon={}, isIconLink=true, linkText="", linkTextStyle={}}: FooterProps) => {
    return (
        <a href={hrefLink} rel="noopener noreferrer" target='_blank' style={hrefStyle}>
            {isIconLink ? (
                <Image source={footerIcon} style={iconStyle} />
            ) : (
                <TranslationView style={linkTextStyle}>{linkText}</TranslationView>
            )}
        </a>
    );
}

export default FooterView;